import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import type { UseUserPayload } from '@hooks/useUser'

interface UserDeletedBannerProps {
  userPayload: UseUserPayload,
}

const UserDeletedBanner = (props: UserDeletedBannerProps) => {
  const { userPayload } = props
  const { isDeleted } = userPayload

  if (!isDeleted) return null

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="orange"
          borderRadius={5}
          color="white"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small" marginBottom="small">User is Inactive</Text>

          <Text fontSize="small" color="bodyFontLightColor" marginTop="small">
            This User has been Deactivated.
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default UserDeletedBanner
